export const GET_OFFER_RESPONSE_BY_ID = "GET_OFFER_RESPONSE_BY_ID";
export const GET_OFFER_RESPONSES = "GET_OFFER_RESPONSES";
